import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postRequest } from 'apis/ApiInstence';

const Add = () => {
    const [formData, setFormData] = useState({
        tag: '',
        name: '',
        durationText: '',
        bestTimeText: '',
        activityText: '',
        location: '',
        description: '',
        images: []
    });
    
    // Local state for itinerary days before package is created
    const [itineraries, setItineraries] = useState([]);
    const [itiForm, setItiForm] = useState({ day: '', title: '', description: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();
    const { loading } = useSelector((state) => state.khajurahoPackage);

    const handleChange = (e) => {
        const { name, type, files, value } = e.target;
        if (type === 'file' && name === 'images') {
            setFormData(prev => ({
                ...prev,
                images: Array.from(files)
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleItiChange = (e) => {
        setItiForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const addLocalItinerary = (e) => {
        e.preventDefault();
        if (!itiForm.day || !itiForm.title) {
            toast.error('Day number and title are required');
            return;
        }
        setItineraries([...itineraries, { ...itiForm, id: Date.now() }]);
        setItiForm({ day: '', title: '', description: '' });
    };

    const removeLocalItinerary = (id) => {
        setItineraries(itineraries.filter(item => item.id !== id));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return;

        if (!formData.name || !formData.tag) {
            toast.error('Tag and Name are required');
            return;
        }
        
        setIsSubmitting(true);

        const data = new FormData();
        data.append('tag', formData.tag);
        data.append('name', formData.name);
        data.append('durationText', formData.durationText);
        data.append('bestTimeText', formData.bestTimeText);
        data.append('activityText', formData.activityText);
        data.append('location', formData.location);
        data.append('description', formData.description);
        formData.images.forEach((img) => data.append('images', img));

        try {
            // Using the project's postRequest
            const res = await postRequest('packages', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (res.status === 200 || res.status === 201) {
                const newPackageId = res.data.data.id;
                
                // Save itineraries in parallel to speed up the process
                const itineraryPromises = itineraries.map(iti => 
                    postRequest('itineraries', {
                        packageId: newPackageId,
                        day: parseInt(iti.day),
                        title: iti.title,
                        description: iti.description
                    })
                );
                await Promise.all(itineraryPromises);

                toast.success('Package and Itinerary added successfully!');
                setIsSubmitting(false);
                navigate('/khajuraho/packages');
            } else {
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error(error);
            toast.error('Error adding package');
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container-fluid mt-5 pb-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Tour Package</h4>
            </div>
            
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="tag" className="adminlables">Tag (e.g. UNESCO Heritage, Wildlife)</label>
                        <input type="text" id="tag" name="tag" value={formData.tag} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="name" className="adminlables">Package Name</label>
                        <input type="text" id="name" name="name" value={formData.name} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="durationText" className="adminlables">Duration</label>
                        <input type="text" id="durationText" name="durationText" value={formData.durationText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="bestTimeText" className="adminlables">Best Time</label>
                        <input type="text" id="bestTimeText" name="bestTimeText" value={formData.bestTimeText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="location" className="adminlables">Location</label>
                        <input type="text" id="location" name="location" value={formData.location} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="activityText" className="adminlables">Activities</label>
                        <input type="text" id="activityText" name="activityText" value={formData.activityText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="description" className="adminlables">Description</label>
                        <textarea rows={3} id="description" name="description" value={formData.description} className="form-control" onChange={handleChange}></textarea>
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="images" className="adminlables">Package Images</label>
                        <input type="file" id="images" multiple name="images" className="form-control btn-block filebg" onChange={handleChange} />
                    </div>
                </div>

                <hr className="my-5" />

                <h5 className="font-weight-bold mb-3" style={{ color: '#e67e22' }}>Add Day-wise Itinerary</h5>
                <div className="row bg-light p-3 rounded mb-4 mx-0 border">
                    <div className="col-sm-2">
                        <label htmlFor="iti-day-add" className="adminlables">Day No.</label>
                        <input type="number" id="iti-day-add" name="day" value={itiForm.day} className="form-control" onChange={handleItiChange} />
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="iti-title-add" className="adminlables">Day Title</label>
                        <input type="text" id="iti-title-add" name="title" value={itiForm.title} className="form-control" onChange={handleItiChange} placeholder="Arrival etc." />
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="iti-desc-add" className="adminlables">Description</label>
                        <input type="text" id="iti-desc-add" name="description" value={itiForm.description} className="form-control" onChange={handleItiChange} />
                    </div>
                    <div className="col-sm-2 d-flex align-items-end">
                        <button type="button" className="btn addbtn btn-block" onClick={addLocalItinerary}>Add Day</button>
                    </div>
                </div>

                {itineraries.length > 0 && (
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="thead-light">
                                <tr>
                                    <th>Day</th>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itineraries.sort((a,b) => a.day - b.day).map((item) => (
                                    <tr key={item.id}>
                                        <td>Day {item.day}</td>
                                        <td>{item.title}</td>
                                        <td>{item.description}</td>
                                        <td>
                                            <button type="button" className="btn btn-sm btn-danger" onClick={() => removeLocalItinerary(item.id)}>Remove</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading || isSubmitting}>
                        {isSubmitting || loading ? 'Adding...' : 'Add Package & Itinerary'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Add;
